// Journal State

export default {
  journalList: []
}
